import { httpClient } from "../axios/axios-api";

class AssetRepository {
  async getAssetUrl(fileKey: string): Promise<{ url: string }> {
    const response = await httpClient.get(`/assets/${fileKey}`);
    return response.data;
  }

  async uploadAsset(folder: string, file: File): Promise<{ filePath: string }> {
    const formData = new FormData();
    formData.append("file", file);
    const response = await httpClient.post(`/assets/${folder}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  }
}

export default new AssetRepository();
